import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { PATHS } from "@constants/Paths";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { PeekStack } from "@piiqtechnologies/ui-components";
import { ReportTypeBox } from "./report-type-box";
import { getReportTypesText } from "./constants/reportTypes";
export const ReportTypes = ({ onPlanSelect, billingPeriod = "annually" }) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const analytics = useAnalytics();
    const reportTypesText = getReportTypesText(intl, billingPeriod);
    const handlePlanSelect = (reportType) => {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("Ai Discoverability || Report Plan Selected", {
            planId: reportType.id,
            planTitle: reportType.title,
        });
        if (reportType.id === "enterprise") {
            window.open("https://www.peek.us/contact", "_blank", "noopener,noreferrer");
            return;
        }
        if (onPlanSelect) {
            onPlanSelect(reportType);
            return;
        }
        navigate(`${PATHS.CHECKOUT}?plan=${encodeURIComponent(reportType.id)}`);
    };
    return (React.createElement(PeekStack, { direction: { xs: "column", lg: "row" }, gap: 3.5, alignSelf: "center", alignItems: "center" }, reportTypesText.map((reportType) => (React.createElement(PeekStack, { key: reportType.id, width: "100%" },
        React.createElement(ReportTypeBox, { reportType: reportType, onSelect: () => handlePlanSelect(reportType) }))))));
};
export default ReportTypes;
